import fr from "./fr"

// Add language selection logic if necessary
const strings = fr

export default strings
